import faker from '@faker-js/faker';
import {
  MockDataStartJourney,
  MockDataViewAudioContent,
  MockDataViewImageContent,
  MockDataViewTextContent
} from './types';

export const mockDataViewImageContent: MockDataViewImageContent = {
  blobName: 'Blob name',
  source: 'https://upload.wikimedia.org/wikipedia/commons/0/0e/Pic_d-anie_oct2008.JPG',
  description:
    'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry'
};

export const mockDataStartJourney: MockDataStartJourney = {
  blobName: 'Blob name'
};

export const mockDataViewAudioContent: MockDataViewAudioContent = {
  blobName: faker.name.firstName(),
  source: 'https://www2.cs.uic.edu/~i101/SoundFiles/StarWars60.wav',
  description: faker.lorem.paragraphs(4),
  title: faker.name.firstName(),
  subTitle: faker.name.jobTitle()
};
export const mockDataViewVideoContent: MockDataViewAudioContent = {
  ...mockDataViewAudioContent,
  source: 'https://storage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4'
};

export const mockDataViewTextContent: MockDataViewTextContent = {
  blobName: faker.name.firstName(),
  title: faker.name.jobTitle(),
  description: faker.lorem.paragraphs(8)
};
